import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import ExpandableCell from 'components/SimpleTable/ExpandableCell';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
		margin: 16,
	},
	searchButton: {
		marginRight: 16,
	},
	searchTable: {
		minHeight: 600,
		marginTop: 30,
		marginRight: 32,
	},
	formField: {
		width: '100%',
	},
});

const searchCols = [
	{ name: 'Item', title: 'Item Code' },
	{ name: 'Description', title: 'Item Name/Description' },
	{ name: 'OnHand', title: 'On Hand' },
	{ name: 'OnOrder', title: 'On Order' },
	{ name: 'CardName', title: 'Vendor Name' },
	{ name: 'ShipToState', title: 'Vendor Ship-To State' },
	{ name: 'U_Notes', title: 'Product Info' },
];

const tableColumnExtensions = [
	{ columnName: 'Item', width: 100 },
	{ columnName: 'Description', width: 325 },
	{ columnName: 'OnHand', width: 80 },
	{ columnName: 'OnOrder', width: 80 },
	{ columnName: 'CardName', width: 200 },
	{ columnName: 'ShipToState', width: 150 },
	//{ columnName: 'U_Notes', width: 300 },
];



class ItemSearch extends React.PureComponent {
	state = {
		values: {
			Item: '',
			Description: '',
			CardCode: '',
			CardName: '',
		},
		searching: false,
		rows: [],
		redirect: '',
	};


	updateSearchVal = memoize(key => event => {
		this.setState({
			values: {
				...this.state.values,
				[ key ]: event.target.value,
			},
		});
	});


	handleSearch = ( e ) => {
		e.preventDefault();
		this.setState({ searching: true, rows: [] });

		svc.send('item', { method: 'search', ...this.state.values }).then(res => {
			this.setState({
				searching: false,
				rows: res.payload.data,
			});
		});
	};


	onRowSelect = ( sel ) => {
		if ( !sel.length ) {
			return false;
		}

		let row = this.state.rows[ sel[ 0 ] ];
		if ( !row.CardCode ) {
			return false;
		}

		this.setState({ redirect: `/businesspartners/view/${row.CardCode}` });
	};


	render() {
		const classes = this.props.classes;
		const tableClass = classnames(classes.searchTable, this.state.searching && 'automat-loading');
		let values = this.state.values;

		return (
			<div>
				<form onSubmit={this.handleSearch} className={classes.formField}>
					<Grid container className={classes.gridRoot} spacing={16}>


						<Grid item xs={12}>
							<Typography variant="h6">Item Search</Typography>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.Item}
								label="Item Code"
								onChange={this.updateSearchVal('Item')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={3} xl={2}>
							<TextField
								type="text"
								value={values.Description}
								label="Item Name/Description"
								onChange={this.updateSearchVal('Description')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardCode}
								label="Vendor Card Code"
								onChange={this.updateSearchVal('CardCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={4} lg={3} xl={2}>
							<TextField
								type="text"
								value={values.CardName}
								label="Vendor Name"
								onChange={this.updateSearchVal('CardName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item>
							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.handleSearch}
								disabled={this.state.searching}
								type={'submit'}
							>
								Search
							</Button>
						</Grid>

						<Grid item xs={12}>
							<Paper className={tableClass}>
								<SimpleTable
									columns={searchCols}
									rows={this.state.rows}
									onRowSelect={this.onRowSelect}
									defaultPageSize={15}
									columnExtensions={tableColumnExtensions}
									cellComponent={ExpandableCell}
								/>
							</Paper>
						</Grid>

					</Grid>

					{
						this.state.redirect
						&& window.location.pathname !== this.state.redirect
						&& <Redirect to={this.state.redirect} push />
					}

				</form>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		appData: state.appData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch(actions.layout.setTitle(title));
		},
	}
};

ItemSearch = withStyles(styles)(ItemSearch);
export default connect(mapStateToProps, mapDispatchToProps)(ItemSearch);